// extracted by mini-css-extract-plugin
module.exports = {"baseOrderList":"BaseOrderList_baseOrderList_3WcpE","headList":"BaseOrderList_headList_3D1jH","bodyList":"BaseOrderList_bodyList_3D6Ln","footList":"BaseOrderList_footList_3CJe_"};